// extracted by mini-css-extract-plugin
module.exports = {"step":"style_step__2v0BY","container":"style_container__p9jUt","title":"style_title__3eb_b","description":"style_description__1iSg3","body":"style_body__35LKO"};